import { defineComponent as r, computed as l, openBlock as a, createElementBlock as s, createElementVNode as t, toDisplayString as d, createCommentVNode as n, normalizeStyle as m, createStaticVNode as p } from "vue";
const f = ["viewBox"], v = /* @__PURE__ */ t("mask", { id: "5622e308-c015-4976-890c-e421d265644a" }, [
  /* @__PURE__ */ t("circle", {
    cx: "256",
    cy: "256",
    r: "256",
    fill: "#fff"
  })
], -1), _ = { mask: "url(#5622e308-c015-4976-890c-e421d265644a)" }, k = { key: 0 }, u = /* @__PURE__ */ p('<path fill="#0052b4" d="M256 0h256v512H0V256Z"></path><path fill="#eee" d="M0 0h256v256H0z"></path><path fill="#0052b4" d="M0 0h75v224H0z"></path><path fill="#d80027" d="M149 0h75v224h-75z"></path><path fill="#eee" d="m323 158 13 21h36v71l-27-43-37 59h18l19-34 39 70 39-70 19 34h18l-37-59-27 43v-39h16l12-20h-28v-12h36l13-21zm43 88h-40v14h40zm76 0h-40v14h40z"></path><path fill="#eee" d="m301 181 13 38-34-23h42l-34 23zm166 0 13 38-34-23h42l-34 23zM339 282l13 38-34-23h42l-34 23zm90 0 13 38-34-23h42l-34 23zm-45 34 13 38-34-23h42l-34 23z"></path>', 6), g = { fill: "none" }, z = ["r"], N = /* @__PURE__ */ r({
  __name: "tf",
  props: {
    flagName: {},
    strokeColor: { default: "#000" },
    strokeWidth: { default: 0 }
  },
  setup(i) {
    const e = i, o = l(() => 512 + 2 * e.strokeWidth), h = l(() => -e.strokeWidth), c = l(() => 256 + e.strokeWidth / 2);
    return (x, w) => (a(), s("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      class: "svg-circle-flags",
      viewBox: `${h.value} ${h.value} ${o.value} ${o.value}`
    }, [
      v,
      t("g", _, [
        e.flagName ? (a(), s("title", k, d(e.flagName), 1)) : n("", !0),
        u
      ]),
      t("g", g, [
        t("circle", {
          cx: "256",
          cy: "256",
          r: c.value,
          fill: "none",
          style: m({ stroke: e.strokeColor, strokeWidth: e.strokeWidth })
        }, null, 12, z)
      ])
    ], 8, f));
  }
});
export {
  N as default
};
//# sourceMappingURL=tf-00a93e66.js.map
